import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { element } from "prop-types";
import { Label, LineAxis } from "@mui/icons-material";
import { Lazy } from "yup";
import VendorRequest from './vendor/VendorRouter'


 const BannerImage = Loadable(lazy(()=> import('./homePage/bannerImage/AddBannerImage')))
  const BannerImageAdd = Loadable(lazy(()=>import('./homePage/bannerImage/BannerImage')))
  const ListBannerImage = Loadable(lazy(()=>import('./homePage/bannerImage/ListBannerImage')))
  const EditBannner = Loadable(lazy(()=>import('./homePage/bannerImage/EditBanner')))

  const ListUspIcon = Loadable(lazy(()=>import('./homePage/icon/listIcon')))
  const AddUspIcon = Loadable(lazy(()=>import('./homePage/icon/AddIcon')))
  const EditIcon = Loadable(lazy(()=>import('./homePage/icon/EditIcon')))

  const HomeList = Loadable(lazy(()=>(import('./homePage/HomeList'))))

  const ListFlex = Loadable(lazy(()=>import('./homePage/fit_flexibility/ListFlex')))
  const AddFlex = Loadable(lazy(()=>import('./homePage/fit_flexibility/AddFlex')))
  const EditFlex = Loadable(lazy(()=>import('./homePage/fit_flexibility/EditFlex')))
    
  const ListTextMon= Loadable(lazy(()=>import('./homePage/textimonials/ListTextimonials')))
  const AddTextMon= Loadable(lazy(()=>import('./homePage/textimonials/AddTextimonials')))
  const EditTextMOn = Loadable(lazy(()=>import('./homePage/textimonials/EditTextimonials')))

  const OwnGymList = Loadable(lazy(()=>(import('./homePage/OwnGymList'))))

  const ListBottom= Loadable(lazy(()=>import('./homePage/bottom_banner/ListBottom')))
  const AddBottom= Loadable(lazy(()=>import('./homePage/bottom_banner/AddBottom_ban')))
  const EditBottom = Loadable(lazy(()=>import('./homePage/bottom_banner/EditBottom')))

  const ListFQA= Loadable(lazy(()=>import('./homePage/fqa_HomePage/ListFQA')))
  const AddFQA= Loadable(lazy(()=>import('./homePage/fqa_HomePage/AddFQA')))
  const EditFQA= Loadable(lazy(()=>import('./homePage/fqa_HomePage/EditFaq')))

const ListBlog = Loadable(lazy(()=>import('./homePage/blog/ListBlog')))
const AddBlog = Loadable(lazy(()=>import('./homePage/blog/AddBlog')))
const CategoryList = Loadable(lazy(()=>import('./homePage/blog/CategoryLIst')))
const ViewPage = Loadable(lazy(()=>import('./homePage/blog/ViewPage')))
const EditBlog = Loadable(lazy(()=>import('./homePage/blog/EditBlog')))

const ListFQA_htw = Loadable(lazy(()=>import('./how_it_works/fqa_htw/ListFQA')))
const AddFQA_htw = Loadable(lazy(()=>import('./how_it_works/fqa_htw/AddFQA')))
const EditFQA_htw = Loadable(lazy(()=>import('./how_it_works/fqa_htw/EditFQA')))

const ListGymGrow = Loadable(lazy(()=>import('./list_your_gym/fit_flexibility/ListFlex')))
const AddGymGrow = Loadable(lazy(()=>import('./list_your_gym/fit_flexibility/AddFlex')))
const EditGymGrow = Loadable(lazy(()=>import('./list_your_gym/fit_flexibility/EditFlex')))

const ListFQA_Lyg = Loadable(lazy(()=>import('./list_your_gym/fqa_LYG/ListFQA')))
const AddFQA_Lyg = Loadable(lazy(()=>import('./list_your_gym/fqa_LYG/AddFQA')))
const EditFQA_Lyg = Loadable(lazy(()=>import('./list_your_gym/fqa_LYG/EditFQA')))

const Trending_Pass = Loadable(lazy(()=>import('./homePage/trending_pass/Trending_Pass')))
 

// ===============================================================End Frontend Cms=================
  
const PasswordChange = Loadable(lazy(()=>import('./AllGym/PasswordChange')))
 const GymProfileById = Loadable(lazy(()=>import('./AllGym/GymProfilebyId')))
  const WaiverAdmin = Loadable(lazy(()=>import('./AllGym/Waiver')))

 const Featuer = Loadable(lazy(()=>import('./feature/Feature')))
 const AllPasses = Loadable(lazy(() => import('./vendor/PassCreate/AllPasses')));
//  const PassList = Loadable(lazy(() => import('./vendor/PassCreate/AllPassList')));
 const AddPass = Loadable(lazy(() => import('./vendor/PassCreate/AddPass')));
 const TempPass = Loadable(lazy(() => import('./vendor/PassCreate/AddTemp')));
 const GymSelectPass = Loadable(lazy(() => import('./vendor/PassCreate/GymSelect')));



 const Reviews = Loadable(lazy(() => import('./reviews/Reviews')));
//  src/app/Admin/vendor/PassCreate/AllPassList.jsx

 const UserPage = Loadable(lazy(()=>import('./user/UserList')))
 const UserProfilePage = Loadable(lazy(()=>import('./user/UserProfile')))
 const ListBookings = Loadable(lazy(()=>import('./bookings/List')))

 const UpcomingPage = Loadable(lazy(()=>import('./UpcomingPage/UpcomingPage')))
 const ContactPage = Loadable(lazy(()=>import('./contact/Contact')))
 const TrendingGym = Loadable(lazy(()=>import('./AllGym/TrendingGym')))

 const GymRevenue = Loadable(lazy(()=>import('./admin/GymRevenues')))
 const ReturningCustom = Loadable(lazy(()=>import('./perfomance/returningCus')))


 const AdminCheck_in = Loadable(lazy(()=>import('./check_in/Check_in')))
 const AddFilter = Loadable(lazy(()=>import('./check_in/AdminFilter')))
 const Admin_Settings = Loadable(lazy(()=>import('./globle-Setting/Setting')))
 const AdminActivities = Loadable(lazy(()=>import('./Activeties/AdminActive')))

 const ListTransition = Loadable(lazy(() => import('./transitionDistribution/List')));

 const GymSeoList = Loadable(lazy(() => import('./seoSection/gym/GymList')));
 const SeoForm = Loadable(lazy(() => import('./seoSection/gym/SeoForm')));
 const BlogSeoList = Loadable(lazy(() => import('./seoSection/blog/BlogList')));
 const Redirection = Loadable(lazy(() => import('./seoSection/Redirection')));
 const BlogSeoForm = Loadable(lazy(() => import('./seoSection/blog/BlogForm')));


//  ===============================================offer page========================

 const GetFree = Loadable(lazy(()=>import('./offerPage/bugonegetfree/GetFree')));
 const CreatePass = Loadable(lazy(()=>import('./offerPage/bugonegetfree/Createpass')));
 const CreateDiscount = Loadable(lazy(()=>import('./offerPage/getDisCode/CreateDisCode')));
 const ListDiscount = Loadable(lazy(()=>import('./offerPage/getDisCode/GetDisCode')));

const AdminRoutes = [
  ...VendorRequest,
  { path: "/banerList/addBanner", element: <BannerImage />}
, { path: "/image", element: <BannerImageAdd /> },
 {path:'/banerList',element:<ListBannerImage />},
 {path:'/banerList/editBanner/:id',element:<EditBannner />},

 {path:'/listUspIcon',element:<ListUspIcon />},
 {path:'/listUspIcon/addUspIcon',element:<AddUspIcon />},
 {path:'/listUspIcon/editIcon/:id',element:<EditIcon />},

 {path:'/homeList',element:<HomeList />},

 {path:'/listFlex',element:<ListFlex />},
 {path:'/listFlex/addFlex',element:<AddFlex />},
 {path:'/listFlex/editFlex/:id',element:<EditFlex />},

 {path:'/listTextMon',element:<ListTextMon />},
 {path:'/listTextMon/addTextMON',element:<AddTextMon />},
 {path:'/listTextMon/editTextMOn/:id',element:<EditTextMOn />},

 {path:'/ownGymList',element:<OwnGymList />},

 {path:'/listBottom',element:<ListBottom />},
 {path:'/listBottom/addBottom',element:<AddBottom/>},
 {path:'/listBottom/editBottom/:id',element:<EditBottom />},

 {path:'/list_Fqa',element:<ListFQA />},
 {path:'/list_Fqa/add_Fqa',element:<AddFQA/>},
 {path:'/list_Fqa/edit-fqa/:id',element:<EditFQA />},

 {path:'/how_it_work/Fqa',element:<ListFQA_htw />},
 {path:'/how_it_work/add_Fqa',element:<AddFQA_htw />},
 {path:'/how_it_work/edit-fqa/:id',element:<EditFQA_htw />},

 {path:'/list_gym/list_grow',element:<ListGymGrow />},
 {path:'/list_gym/add_grow',element:<AddGymGrow />},
 {path:'/list_gym/edit_grow/:id',element:<EditGymGrow />},

 {path:'/list_gym/Fqa',element:<ListFQA_Lyg />},
 {path:'/list_gym/add_Fqa',element:<AddFQA_Lyg />},
 {path:'/list-gym/edit-fqa/:id',element:<EditFQA_Lyg />},



 {path:'/trending_pass',element:<Trending_Pass />},



// ==================================================blog Routing============
{path:'/listBlog',element:<ListBlog />},
{path:'/listBlog/addBlog',element:<AddBlog />},
{path:'/listBlog/CategoryList/:type/:id',element:<CategoryList />},
{path:'/listBlog/viewBlog/:type/:id',element:<ViewPage />},
{path:'/blog/edit-blog/:id',element:<EditBlog />},

  {path:'/gymbyId/:id',element:<GymProfileById />},
  {path:'/admin-waiver/:id/:vendorId',element:<WaiverAdmin />},

  {path:'/feature',element:<Featuer />},
  {path:'/AllPasses',element:<AllPasses />},
  // {path:'/PassList',element:<PassList />},
  {path:'/add-pass',element:<AddPass />},
  {path:'/temp-pass',element:<TempPass />},
  {path:'/select-gym-pass/:id',element:<GymSelectPass />},
  {path:'/reviews',element:<Reviews />},


  

//    { path: "/natification-accesses", element: <NotificationSettings /> }
  {path:'/userlist',element:<UserPage/>},

  {path:'/password-change',element:<PasswordChange/>},
  {path:'/contact',element:<ContactPage/>},
  {path:'/userProfile/:id',element:<UserProfilePage/>},

  {path:'/bookinglist',element:<ListBookings/>},
  {path:'/UpcomingPage',element:<UpcomingPage/>},
  {path:'/trendingGym',element:<TrendingGym />},

  {path:"/gym-revenue",element:<GymRevenue />},
  {path:"/returing-costomer",element:<ReturningCustom />},
 {path:"/admin-check-in",element:<AdminCheck_in />},
 {path:"/admin-check-in-filter",element:<AddFilter />},
 {path:"/admin-setting",element:<Admin_Settings />},
 {path:"/admin-activities",element:<AdminActivities />},

 {path:'/partner-payment',element:<ListTransition />},

 {path:'/seo-gym-list',element:<GymSeoList />},
 {path:'/seo-gym-form/:id',element:<SeoForm />},
 {path:'/seo-blog',element:<BlogSeoList />},
 {path:'/seo-blog-form/:id',element:<BlogSeoForm />},
 {path:'/redirection',element:<Redirection />},

//  =============================================offer page========================
{path:'/buy-one-get-free',element:<GetFree />},
 {path:'/create-free-pass',element:<CreatePass />},
 {path:'/getDis-code',element:<ListDiscount />},
 {path:'/create-dis-code',element:<CreateDiscount />},
 

  ];

export default AdminRoutes;
